import { PromoTagProps } from '@snack-uikit/promo-tag';
import { ValueOf } from '@snack-uikit/utils';

export const Formats = [
  {
    title: 'Онлайн',
    value: 'online',
  },
  {
    title: 'Офлайн',
    value: 'offline',
  },
  {
    title: 'Гибрид',
    value: 'hybrid',
  },
];

export const Audience = [
  {
    title: 'Для IT',
    value: 'it',
  },
  {
    title: 'Для студентов',
    value: 'students',
  },
  {
    title: 'Для бизнеса',
    value: 'business',
  },
];
// TODO: can be removed due to new HeroEvent component?
export const HERO_BUTTONS = {
  registration: 'регистрация',
  watch: 'смотреть запись',
  additionaMaterials: 'Получить материал',
};

export const CATEGORY_TAGS = {
  News: 'news',
  Article: 'article',
  PressRelease: 'press-release',
  Conference: 'conference',
  Webinar: 'webinars',
  Course: 'course',
  Certification: 'certification',
} as const;

export const CATEGORY_TAG_META: Record<
  ValueOf<typeof CATEGORY_TAGS>,
  PromoTagProps
> = {
  [CATEGORY_TAGS.News]: { text: 'Новость', appearance: 'neutral' },
  [CATEGORY_TAGS.Article]: { text: 'Статья', appearance: 'neutral' },
  [CATEGORY_TAGS.PressRelease]: { text: 'Пресс-релиз', appearance: 'neutral' },
  [CATEGORY_TAGS.Conference]: { text: 'Конференция', appearance: 'violet' },
  [CATEGORY_TAGS.Webinar]: { text: 'Вебинар', appearance: 'violet' },
  [CATEGORY_TAGS.Course]: { text: 'Курс', appearance: 'blue' },
  [CATEGORY_TAGS.Certification]: { text: 'Сертификация', appearance: 'orange' },
};
